<template>
  <div v-if="changeDateLabel" class="level-formula-notice" role="note">
    <div>
      <strong>Desde el {{ changeDateLabel }} tu nivel se calcula con la fórmula nueva:</strong>
      reclamos {{ current.claims }}%, estrellas {{ current.stars }}% y espera del repartidor {{ current.dealerWait }}%.
      Las quincenas anteriores se calcularon con la fórmula de antes
      (reclamos {{ previous.claims }}%, tardanza {{ previous.lateness }}%, estrellas {{ previous.stars }}%).
    </div>
    <LinkPdf />
  </div>
</template>

<script>
import LinkPdf from "@/components/Metrics/LinkPdf";
import { CURRENT_FORMULA_WEIGHTS, PREVIOUS_FORMULA_WEIGHTS } from "@/utils/levelFormulaWeights";

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export default {
  name: "LevelFormulaNotice",
  components: { LinkPdf },
  props: {
    changeDate: { type: String, default: null }
  },
  data: () => ({
    current: CURRENT_FORMULA_WEIGHTS,
    previous: PREVIOUS_FORMULA_WEIGHTS
  }),
  computed: {
    changeDateLabel() {
      const [, , month, day] = (this.changeDate || "").match(ISO_DATE) || [];
      return day ? `${day}/${month}` : "";
    }
  }
};
</script>

<style scoped>
.level-formula-notice {
  padding: 10px 14px;
  margin: 0 15px 14px;
  border-radius: 8px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0c4a6e;
  font-size: 13px;
  line-height: 1.4;
}
</style>
